import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Breadcrumb from '../Breadcrumb';
import './styles.css';

const getMenuText = (path) => {
  switch (path) {
    case 'overview': return <FormattedMessage id="repvisits.menu.overview" defaultMessage="Overview" />;
    case 'search': return <FormattedMessage id="repvisits.menu.searchAndSchedule" defaultMessage="Search and Schedule" />;
    case 'calendar': return <FormattedMessage id="repvisits.menu.calendar" defaultMessage="Calendar" />;
    case 'travel-plan': return <FormattedMessage id="repvisits.menu.travelPlan" defaultMessage="Travel Plan" />;
    case 'contacts': return <FormattedMessage id="repvisits.menu.contacts" defaultMessage="Contacts" />;
    case 'recommendations': return <FormattedMessage id="repvisits.menu.recommendations" defaultMessage="Recommendations" />;
    case 'visit-feedback': return <FormattedMessage id="repvisits.menu.visitFeedback" defaultMessage="Visit Feedback" />;
    case 'notifications': return <FormattedMessage id="repvisits.menu.notifications" defaultMessage="Notifications" />;
    case 'requests': return <FormattedMessage id="repvisits.notifications.menu.request" defaultMessage="Requests" />;
    case 'activity': return <FormattedMessage id="repvisits.notifications.menu.activity" defaultMessage="Activity" />;
    case 'hsavailable': return <FormattedMessage id="repvisits.notifications.menu.hsavailable" defaultMessage="High Schools Now Available" />;
    default: return null;
  }
};

const Breadcrumbs = (props) => {
  if (props.path.length <= 3) {
    return (
      <Breadcrumb className={props.className}>
        <Breadcrumb.Section>{getMenuText(props.path[2])}</Breadcrumb.Section>
      </Breadcrumb>
    );
  }

  if (props.path.length === 4) {
    return (
      <Breadcrumb className={props.className}>
        <Breadcrumb.Section styleName="breadcrumbSection">{getMenuText(props.path[2])}</Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section styleName="breadcrumbSection">{getMenuText(props.path[3])}</Breadcrumb.Section>
      </Breadcrumb>
    );
  }

  return null;
};

Breadcrumbs.propTypes = {
  path: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default Breadcrumbs;
